import React from 'react'
import { QRCode } from '@node-space/ui-components'
import { useProtocolContext, useWalletContext } from 'hooks/context'

type WalletQRCodeProps = {
  address?: string
}

export const WalletQrCode = ({ address }: WalletQRCodeProps) => {
  const wallet = useWalletContext()
  const { currentProtocol } = useProtocolContext()
  const value = address
    ? address
    : currentProtocol?.address
      ? currentProtocol.address
      : wallet?.address
  return <QRCode value={value || ''} />
}
